import React, { FC } from "react";

import { ESRS_COLORS } from "../Stakeholders/components/ESRS.constants";

import { Box } from "@components/base";

interface ESRSAreaChipProps {
  label: string;
  uppercase?: boolean;
}

const ESRSAreaChip: FC<ESRSAreaChipProps> = ({ label, uppercase = true }) => {
  const colors = ESRS_COLORS[label.toUpperCase()];

  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: colors?.background,
        border: `1px solid ${colors?.border}`,
        color: colors?.color,
        borderRadius: "2px",
        px: 1,
        py: 0.25,
        fontSize: "12px",
        fontWeight: 500,
        lineHeight: 1,
        maxWidth: "100%",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        textTransform: uppercase ? "uppercase" : "none",
      }}
    >
      {label}
    </Box>
  );
};

export default ESRSAreaChip;
